import React from 'react';
import { IconSvgProps } from '@models/common';

const CrossCircle: React.FC<IconSvgProps> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.00016 14.6666C11.6821 14.6666 14.6668 11.6819 14.6668 7.99998C14.6668 4.31808 11.6821 1.33331 8.00016 1.33331C4.31826 1.33331 1.3335 4.31808 1.3335 7.99998C1.3335 11.6819 4.31826 14.6666 8.00016 14.6666Z'
        fill='currentColor'
      />
      <path
        d='M10 6C8.4379 7.5621 6 10 6 10M6 6C7.5621 7.5621 10 10 10 10'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CrossCircle;
